














import { defineComponent, computed } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import SwitchContainer from '@/components/common/switch-container/index.vue';

const name = 'ttam-tracking-viewability-switch';

export default defineComponent({
  name,

  components: { SwitchContainer },

  model: { prop: 'value', event: 'change' },

  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: {
      type: String,
      default: i18n.t('module_track_url_view_title_with_moat'),
    },
    titleHint: { type: String, default: i18n.t('module_track_url_view_hint') },
    switchHint: { type: String, default: '' },
  },

  setup(props, ctx) {
    const _value = computed({
      get: () => props.value,
      set: val => {
        ctx.emit('change', val);
        ctx.emit('input', val);
      },
    });

    return {
      name,
      _value,
    };
  },
});
